var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddressPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/address-pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/address-pin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7291862,21.5964346 C6.05350243,13.3683811 5,12.5239236 5,9.49998212 C5,5.35784112 8.35784112,2 12.4999821,2 C16.6421231,2 19.9999642,5.35784112 19.9999642,9.49998212 C19.9999642,12.5239236 18.9464618,13.3683811 13.270778,21.5964346 C12.8983119,22.1344964 12.1016142,22.1344582 11.7291862,21.5964346 Z M12.4999821,12.6249747 C14.2258615,12.6249747 15.6249747,11.2258615 15.6249747,9.49998212 C15.6249747,7.77410275 14.2258615,6.37498957 12.4999821,6.37498957 C10.7741027,6.37498957 9.37498957,7.77410275 9.37498957,9.49998212 C9.37498957,11.2258615 10.7741027,12.6249747 12.4999821,12.6249747 Z",
    id: "location",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPin);
export default __webpack_public_path__ + "static/media/address-pin.9fdec34a.svg";
export { ForwardRef as ReactComponent };